/**
 * Vertex360 system theme for AI surfaces — matches global app (Quick Snapshot, buttons).
 * Primary gradient: #4B6CB7 → #293F6A (see index.css `.bg-gradient`).
 */

export const AI_PRIMARY = "#4B6CB7";
export const AI_PRIMARY_HOVER = "#3d5aa0";
export const AI_PRIMARY_DARK = "#293F6A";
export const AI_PRIMARY_MUTED_BG = "#ECF0FD";
export const AI_PRIMARY_TEXT = "#02397A";

/** Tailwind class bundles — use these instead of custom violet / teal */
export const AI_THEME = {
  primary: AI_PRIMARY,
  primaryHover: AI_PRIMARY_HOVER,
  primaryDark: AI_PRIMARY_DARK,
  mutedBg: AI_PRIMARY_MUTED_BG,
  text: AI_PRIMARY_TEXT,

  /** Solid primary button (matches CustomButton primary) */
  btnPrimary:
    "background-gradient border-gradient text-white shadow-sm hover:opacity-95",
  /** Outlined / secondary */
  btnSecondary:
    "border border-[#4B6CB7] bg-[#ECF0FD] text-[#4B6CB7] hover:bg-[#4B6CB7]/10",
  /** Icon chip on white */
  iconChip: "bg-[#ECF0FD] text-[#4B6CB7]",
  /** Section header strip */
  headerStrip: "border-blue-100 bg-[#ECF0FD]/80",
  /** Card accent border */
  cardBorder: "border-blue-100",
  /** Muted info panel */
  panelMuted: "border-blue-100 bg-[#ECF0FD]/60",
  /** Text links */
  link: "text-[#4B6CB7] hover:text-[#293F6A]",
  /** Spinner */
  spinner: "border-blue-200 border-t-[#4B6CB7]",
  /** Status icon default (analyzed, no issue) */
  statusIcon:
    "border-blue-200 bg-[#ECF0FD] text-[#4B6CB7] hover:bg-blue-50 hover:shadow-sm",
  /** Hero / modal header — system blue gradient */
  heroHeader: "bg-gradient text-white",
  /** Filter chip active */
  filterActive: "bg-gradient text-white",
  /** Table row hover */
  rowHover: "hover:bg-[#ECF0FD]/80",
  /** Chart stroke/fill */
  chartColor: AI_PRIMARY,
};

export default AI_THEME;
